























































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import { dom } from '@fortawesome/fontawesome-svg-core';
import 'firebaseui/dist/firebaseui.css';
import User from './model/User';
import { COLLECTION_ROLES, COLLECTION_USERS } from './model/AppConstants';
import RoleType from './userManagement/RoleType';
import FirebaseUtil from './model/FirebaseUtil';
import PermUtil from './model/PermUtil';
import StateType from './model/typelist/StateType';
import CityType from './model/typelist/CityType';
import Notification from './components/Notification.vue';

@Component({
  components: {
    Notification,
  },
})
export default class App extends Vue {
  drawer = false;

  group = null;

  messages= 0;

  icon = false;

  absolute= true;

  isShowing= false;

  isVisible= false;

  overlay= false;

  searchResult = [] as any;

  searchKey = '';

  mounted() {
    this.$nextTick();
    dom.watch();
    this.$store.state.firebase.auth().onAuthStateChanged((user: any) => {
      if (user) {
        this.$store.dispatch('bindCurrentUser', user.uid);
        this.$store.dispatch('findUser', { id: user.uid }).then(() => {
          if (this.$store.state.currentUser === '') {
            const userObj = new User();
            userObj.uid = user.uid;
            userObj.userName = user.displayName;
            userObj.state = { ...StateType.updateState };
            userObj.city = { ...CityType.updateCity };
            userObj.photoURL = user.photoURL;
            userObj.backPhotoURL = user.photoURL;
            userObj.email = user.email;
            userObj
              .roles.push(FirebaseUtil.ObjectToRef(COLLECTION_ROLES, RoleType.userRoleType.code));
            this.$store.dispatch('addToCollection', {
              collection: COLLECTION_USERS,
              doc: user.uid,
              payload: { ...userObj },
            });
            this.$store.commit('setUser', userObj);
            this.$store.dispatch('bindCurrentUser', user.uid);
          }
          const url = this.$route.query.redirect || '/' as any;
          this.$router.push(url)
        });
      } else {
        this.$store.commit('setUser', null);
      }
    });
  }

  redirect() {
    this.isShowing = !this.isShowing;
    this.$router.push('/notification');
  }

  showUserProfile(id: any) {
    this.searchResult = [];
    this.$router.push(`/userProfile/${id}`);
  }

  showing() {
    this.isShowing = !this.isShowing;
  }

  mobileNotify() {
    this.isVisible = !this.isVisible;
  }

  logout() {
    this.$store.state.firebase.auth().signOut()
      .then(() => {
        this.$router.push('/login');
      });
  }

  doSearch(searchKey: any) {
    if (searchKey) {
      const filtered = this.$store.state.people
        .filter((user: any) => (user.userName.toUpperCase().match(searchKey.toUpperCase())));
      this.searchResult = filtered;
    } else {
      this.searchResult = [];
    }
  }

  get authenticated() {
    return this.$store.getters.authenticated;
  }
  // eslint-disable-next-line
  get showRoles() {
    return PermUtil.canViewRoles();
  }

  get photoURL() {
    if (this.$store.state.freshCurrentUser) {
      return this.$store.state.freshCurrentUser.photoURL;
    }
    return '';
  }

  get username() {
    if (this.$store.state.currentUser) {
      return this.$store.state.currentUser.displayName;
    }
    return '';
  }

  get email() {
    if (this.$store.state.currentUser) {
      return this.$store.state.currentUser.email;
    }
    return '';
  }

  get uid() {
    if (this.$store.state.currentUser) {
      return this.$store.state.currentUser.uid;
    }
    return '';
  }

  get freshCurrentUser() {
    return this.$store.state.freshCurrentUser;
  }

  mobileTabs = [
    {
      path: 'Home',
      goto: '',
      icon: 'fas fa-home',
    },
    {
      path: 'Connections',
      goto: 'connections',
      icon: 'fas fa-user-friends',
      menu: [
        {
          path: 'Sent Requests',
          goto: '/sentReqs',
        },
        {
          path: 'Friend Requests',
          goto: '/reciveds',
        },
        {
          path: 'People',
          goto: '/people',
        },
      ],
    },
    {
      path: 'Messenger',
      goto: 'messenger',
      icon: 'fas fa-sms',
    },
    {
      path: 'Notification',
      goto: 'notification',
      icon: 'fas fa-bell',
    },
  ];

  get changes() {
    return this.$store.state.chatRooms.filter((doc: any) => (
      doc.participants.find((Obj: any) => (Obj.id === this.currentUser.uid))));
  }
  // eslint-disable-next-line
  get showAdmin() {
    return PermUtil.showAdminTab();
  }

  @Watch('changes')
  onPropertyChanged(value: any, oldValue: any) {
    this.messages += 1;
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }

  updateUser(id: any) {
    this.$router.push(`/userProfile/${id}`);
  }
}
